import angular from 'angular'
import template from './template.html'
import fuzzySearch from './fuzzysearch'
const tree = angular.module('app.yTree', [])

export default tree.name
/**
 * @param config   ztree 的 config配置
 * @param treeData   ztree 的 数据，扁平化数组
 * @param nodeClick   点击树节点回调，返回值当前点击节点对象
 * @param nodeCheck   勾选/取消勾选树节点回调，返回值当前点击节点对象
 * @param disabledNodes   禁止勾选选树节点，数组类型
 * @param config.isCheckall   自定义属性 是否展示全选功能
 *
 */
tree.directive('yTree', function () {
    return {
        require: '?ngModel',
        restrict: 'AE',
        template: template,
        scope: {
            config: '<',
            treeData: '<',
            nodeClick: '=',
            nodeCheck: '=',
            disabledNodes: '<',
        },
        link: function ($scope, element, attrs, ngModel) {
            $scope.treeId = `y_tree_${Math.random().toString().substring(2, 10)}`
            var setting = {
                check: {
                    //如果没有设置配置项，取默认配置
                    enable: true, //显示不显示复选框
                    chkboxType: {
                        Y: 's',
                        N: 'ps',
                    },
                },
                data: {
                    simpleData: {
                        enable: true, //true / false 分别表示 使用 / 不使用 简单数据模式
                        idKey: 'orgId', //节点数据中保存唯一标识的属性名称 默认值id
                        pIdKey: 'parentOrgId', //节点数据中保存其父节点唯一标识的属性名称 默认值："pId"
                        rootPId: null, // 用于修正根节点父节点数据，即 pIdKey 指定的属性值 默认值：null
                    },
                    key: {
                        name: 'orgName',
                    },
                },
                view: {
                    showIcon: false, //是否显示节点的图标
                    // showLine: false, //是否显示节点之间的连线
                },
                callback: {
                    onCheck: function (event, treeId, treeNode) {
                        var treeObj = $.fn.zTree.getZTreeObj($scope.treeId)
                        // var nodes = treeObj.getCheckedNodes(true);
                        var nodes = treeObj.getNodes()
                        var allNodes = treeObj.transformToArray(nodes)
                        var checkedNodes = allNodes.filter(function (ele) {
                            return ele.checked === true
                        })
                        if ($scope.config && $scope.config.isCheckall) {
                            if (checkedNodes.length === allNodes.length) {
                                $scope.checkAll = true
                            } else {
                                $scope.checkAll = false
                            }
                        }
                        $scope.$apply(function () {
                            ngModel.$setViewValue(checkedNodes)
                        })
                        $scope.nodeCheck && $scope.nodeCheck(treeNode)
                    },
                    onClick: function (event, treeId, treeNode, clickFlag) {
                        $scope.nodeClick && $scope.nodeClick(treeNode)
                    },
                },
            }

            if ($scope.config) {
                setting = $.extend(true, setting, $scope.config)
            }
            $scope.$watch('treeData', function (n, o) {
                if (n) {
                    $.fn.zTree.init($(`#${$scope.treeId}`), setting, n)
                    fuzzySearch($scope.treeId, '#search_' + $scope.treeId)
                    if ($scope.disabledNodes && $scope.disabledNodes.length > 0) {
                        let idKey = setting.data.simpleData.idKey
                        let treeObj = $.fn.zTree.getZTreeObj($scope.treeId)
                        let nodes = treeObj.getNodes()
                        var allNodes = treeObj.transformToArray(nodes)
                        $scope.disabledNodes.forEach((ele) => {
                            for (var i = 0, l = allNodes.length; i < l; i++) {
                                const element = allNodes[i]
                                if (ele[idKey] === element[idKey]) {
                                    treeObj.setChkDisabled(element, true)
                                    break
                                }
                            }
                        })
                    }
                }
            })
            $scope.checkAllChange = function () {
                let treeObj = $.fn.zTree.getZTreeObj($scope.treeId)
                let arr = []
                if ($scope.checkAll) {
                    treeObj.checkAllNodes(true)
                    let nodes = treeObj.getNodes()
                    arr = treeObj.transformToArray(nodes)
                } else {
                    treeObj.checkAllNodes(false)
                }
                ngModel.$setViewValue(arr)
            }
        },
    }
})



// WEBPACK FOOTER //
// ./src/components/yTree/index.js